import type { MemberInvitationLink } from '@tribeplatform/gql-client/types'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getMemberInvitationLinkKey } from '../../utils/keys/authToken.keys.js'

export const useInvitationLink = (options?: {
  useQueryOptions?: UseQueryOptions<MemberInvitationLink>
}) => {
  const { useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const memberInvitationLinkKey = getMemberInvitationLinkKey()

  return useQuery<MemberInvitationLink>(
    memberInvitationLinkKey,
    () => client.invitations.getLink(),
    useQueryOptions,
  )
}
